import { FC, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { isMobileSelector } from 'selectors/viewportSelectors'
import * as Hammer from 'hammerjs'

type SwipeHandlerProps = {
  onSwipedRight?: () => void
  onSwipedLeft?: () => void
}
export const SwipeHandler: FC<SwipeHandlerProps> = (props) => {
  const { children } = props
  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const { current } = rootRef
    const { onSwipedRight, onSwipedLeft } = props
    if (!current || (!onSwipedRight && !onSwipedLeft)) {
      return
    }

    const mc = new Hammer.Manager(current)
    const hammer = new Hammer.Swipe()
    mc.add([hammer])

    if (onSwipedLeft) {
      mc.on('swipeleft', onSwipedLeft)
    }

    if (onSwipedRight) {
      mc.on('swiperight', onSwipedRight)
    }

    return () => {
      mc.off('swipeleft', onSwipedLeft)
      mc.off('swiperight', onSwipedRight)
      mc.stop(true)
      mc.destroy()
    }
  }, [props])

  const isMobile = useSelector(isMobileSelector)

  if (!isMobile) {
    return <>{ children }</>
  }

  return (
    <div ref={ rootRef }>
      { children }
    </div>
  )
}
